import '../../../base/css/base.pcss';
import '../../../base/js/base';

import '../../parts/header/index';
import '../../parts/footer/index';

/* modules */
import '../../modules/white-paper-download-panel/index';

/* shortcodes */
import '../../shortcodes/submit-button/index';

import './single.pcss';
import './single';